import { render, staticRenderFns } from "./WebLayout.vue?vue&type=template&id=1e10617f"
import script from "./WebLayout.vue?vue&type=script&lang=ts"
export * from "./WebLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./WebLayout.vue?vue&type=custom&index=0&blockType=FarmaciaPopup"
if (typeof block0 === 'function') block0(component)

export default component.exports